/**
 * control-tower 埋点入口：仅项目配置，逻辑在 @cw/shared
 * app_name 由 VITE_APP_TYPE 区分 client / admin
 */
import { createAppTracking, type TrackingAppName } from '@cw/shared'
import { getAppType, getAppEnv } from '@/utils/app-config'

const appType = getAppType()
const appName: TrackingAppName = appType === 'admin' ? 'cargowarex-admin' : 'cargowarex-client'

export const {
  initTracking,
  syncTrackingIdentify,
  resetTracking,
  trackEvent,
  setupTabClickTracking
} = createAppTracking({
  enabled: import.meta.env.VITE_SENSORSWAVE_ENABLED === 'true',
  token: import.meta.env.VITE_SENSORSWAVE_TOKEN || '',
  apiHost: import.meta.env.VITE_SENSORSWAVE_API_HOST || '',
  appName,
  endpoint: appType,
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  env: getAppEnv()
})
